import * as React from 'react';
import './loading.css';

const LoadingComponent = () => (
  <div className="loading-wrapper">
    <div className="preloader-wrapper big active">
      <div className="spinner">
        <div className="bounce1"/>
        <div className="bounce2"/>
        <div className="bounce3"/>
      </div>
    </div>
  </div>
);

export default LoadingComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/loading/Loading.component.tsx